import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface PlayerPosition {
  x: number;
  y: number;
}

interface PlayerState {
  visible: boolean;
  expanded: boolean;
  sideCollapsed: boolean;
  dockSide: 'left' | 'right';
  position: PlayerPosition;
  volume: number;
  selectedAudioUrl: string;

  open: () => void;
  close: () => void;
  toggle: () => void;
  setExpanded: (expanded: boolean) => void;
  setSideCollapsed: (collapsed: boolean) => void;
  setDockSide: (side: 'left' | 'right') => void;
  setPosition: (position: PlayerPosition) => void;
  setVolume: (volume: number) => void;
  setSelectedAudioUrl: (url: string) => void;
}

export const usePlayerStore = create<PlayerState>()(
  persist(
    (set, get) => ({
      visible: true,
      expanded: true,
      sideCollapsed: false,
      dockSide: 'right',
      position: { x: 0, y: 80 },
      volume: 0.7,
      selectedAudioUrl: '',

      open: () => set({ visible: true }),
      close: () => set({ visible: false }),
      toggle: () => set({ visible: !get().visible }),
      setExpanded: (expanded) => set({ expanded }),
      setSideCollapsed: (sideCollapsed) => set({ sideCollapsed }),
      setDockSide: (dockSide) => set({ dockSide }),
      setPosition: (position) => set({ position }),
      setVolume: (volume) => set({ volume: Math.max(0, Math.min(1, Number(volume) || 0)) }),
      setSelectedAudioUrl: (url) => set({ selectedAudioUrl: String(url || '').trim() }),
    }),
    {
      name: 'music-player-ui',
      version: 2,
    },
  ),
);
